module.exports = __webpack_public_path__ + "static/media/unbound8.38e9a039.png";